<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <role-form v-if="isInitialized" v-bind="formData" @stored="onStored"></role-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import RoleForm from '../../components/role/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      RoleForm,
    },

    computed: {
      /**
       * @return {boolean}
       */
      modelExists() {
        return _.has(this.formData, 'model.id');
      },

      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (this.modelExists) {
          return 'Edit Role';
        }

        return 'Create Role';
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-role-table');
      },
    },

    created() {
      eventBus.$on('show-role-form-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-role-form-dialog', this.show);
    }
  }
</script>
